export enum LoginError {
    INVALID_EMAIL = 'Please enter a valid email address using the following format: joe@example.com.',
    UNKNOWN_EMAIL = 'It seems like your email address is invalid. Please try again and if the message persists, please give us a call on 03309124843.',
    INVALID_POSTCODE = 'It seems like your postcode is invalid. Please try again and if the message persists, please give us a call on 03309124843.',
}
